import React, { Component } from 'react';
import { CaptionText, grey600 } from '@paypalcorp/pp-react';
import glamorous from 'glamorous';

const TermsOl = glamorous(CaptionText)({
  listStyleType: 'disc',
  textAlign: 'left',
});

const Term = glamorous(CaptionText)({
  margin: '10px 0px 10px 10px',
});

export default class DonationTerms extends Component {
  render() {
    const termsKey =
      this.props.donationTerms || 'label.donation-enrolled-terms';
    let terms = this.props.i18n(termsKey);

    terms = Array.isArray(terms) ? terms : [];
    return (
      <TermsOl as='ol' style={{ color: grey600 }}>
        {terms.map((term, index) => {
          return (
            <Term as='li' key={`donation-term-${index}`}>
              {term}
            </Term>
          );
        })}
      </TermsOl>
    );
  }
}
